import React from "react";
import ReactDOM from "react-dom";
import classnames from "classnames";
import { CloseIcon } from "../../icons/Close";
import PremiumImg from "../../apps/Cards/images/premium-simple.png";
import StandardImg from "../../apps/Cards/images/standard.png";
import { CheckBoldIcon } from "../../apps/Cards/icons/CheckBold";
import { CloseBoldIcon } from "../../apps/Cards/icons/CloseBold";
import { usePopup } from "../../hooks/usePopup";
import "./PopupAccess.scss";
import BrowserLink from "../BrowserLink";

export const PopupAccess = ({
  access,
  enrollProduct,
  closeModal,
  redirectionObjectTitle
}) => {
  const isShowStandard = access !== 'Premium';

  usePopup(closeModal);

  return ReactDOM.createPortal(
    <div className="PopupAccess">
      <div className="PopupAccess__backdrop" onClick={(e) => {
            // actid=7
            window.analytics?.track("button:click", {
              "button_name": "close",
              "parent_object_title": redirectionObjectTitle,
              "title": "To access this content, you must purchase",
            });
            closeModal(e);
          }} />

      <div className="PopupAccess__window">
        <div className="PopupAccess__head">
          {enrollProduct ? (
            <>
              <p className="PopupAccess__description">
                To access this content, you must{" "}
                {!!access?.length && enrollProduct
                  ? `complete one of the following
                actions`
                  : ""}
                :
              </p>
              {!!access?.length && (
                <p className="PopupAccess__description">
                  <span>Purchase </span>
                  <BrowserLink
                    href="src/components/PopupAccess/PopupAccess"
                    className={classnames("PopupAccess__store-link")}
                  >
                    Poker Coaching Premium Membership
                  </BrowserLink>
                  <BrowserLink href={enrollProduct.link} className="PopupAccess__btn">
                    buy now
                  </BrowserLink>
                </p>
              )}
              {!!enrollProduct && (
                <p className="PopupAccess__description">
                  <span>Purchase </span>

                  <BrowserLink
                    href={enrollProduct.link}
                    className="PopupAccess__store-link"
                  >
                    {enrollProduct.title}
                  </BrowserLink>
                  <BrowserLink href={enrollProduct.link} className="PopupAccess__btn">
                    buy now
                  </BrowserLink>
                </p>
              )}
            </>
          ) : (
            <>
              <p className="PopupAccess__description">
                To access this content, you must purchase
              </p>
              <p className="PopupAccess__description">
                <span>Poker Coaching </span>
                <BrowserLink
                  href="https://pokercoaching.com/home/pricing/"
                  className={classnames("PopupAccess__store-link", {
                    "PopupAccess__store-link_standard": access === "Standard",
                  })}
                  onClick={(e) => {
                    // actid=7.3
                    window.analytics?.track("button:click", {
                      "button_name": `${access} Membership.`,
                      "parent_object_title": redirectionObjectTitle,
                      "title": "To access this content, you must purchase",
                      "url": "https://pokercoaching.com/home/pricing/"
                    });
                  }}
                >
                  {access} Membership.
                </BrowserLink>
              </p>
            </>
          )}
          <button className="PopupAccess__close" onClick={(e) => {
            // actid=7
            window.analytics?.track("button:click", {
              "button_name": "close",
              "parent_object_title": redirectionObjectTitle,
              "title": "To access this content, you must purchase",
            });
            closeModal(e);
          }}>
            <CloseIcon />
          </button>
        </div>

        {!enrollProduct && (
          <div className="PopupAccess__body">
            <table
              className={classnames("PopupAccess__table", {
                PopupAccess__table_extended: isShowStandard,
              })}
            >
              <thead>
                <tr>
                  <th>Plans</th>
                  <th>
                    <img src={PremiumImg} alt="" />
                  </th>
                  {isShowStandard && (
                    <th>
                      <img src={StandardImg} alt="" />
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Interactive Poker Hand Quizzes</td>
                  <td>1600+</td>
                  {isShowStandard && <td>500+</td>}
                </tr>
                <tr>
                  <td>Advanced Coaching Classes</td>
                  <td>600+</td>
                  {isShowStandard && <td>200+</td>}
                </tr>
                <tr>
                  <td>50+ Homework webinars with Jonathan Little</td>
                  <td>
                    <CheckBoldIcon />
                  </td>
                  {isShowStandard && (
                    <td>
                      <CheckBoldIcon />
                    </td>
                  )}
                </tr>
                <tr>
                  <td>
                    Free access to Poker Courses <span>(worth $6,946)</span>
                  </td>
                  <td>70+</td>
                  {isShowStandard && (
                    <td>
                      <CloseBoldIcon fillOpacity="0.3" />
                    </td>
                  )}
                </tr>
                <tr>
                  <td />
                  <td><BrowserLink href="https://pokercoaching.com/coupons/PREMIUMF79" className="PopupAccess__premium-btn"
                    onClick={() => {
                      // actid=7.2
                      window.analytics?.track("button:click", {
                        "button_name": "Try premium for free",
                        "parent_object_title": redirectionObjectTitle,
                        "title": "To access this content, you must purchase",
                        "url": "https://pokercoaching.com/coupons/PREMIUMF79"
                      });
                    }}
                  >Try premium for free</BrowserLink></td>
                  {isShowStandard && (
                    <td><BrowserLink href="https://pokercoaching.com/coupons/StandardF39" className="PopupAccess__standard-btn"
                      onClick={() => {
                        // actid=7.2
                        window.analytics?.track("button:click", {
                          "button_name": "Try standard for free",
                          "parent_object_title": redirectionObjectTitle,
                          "title": "To access this content, you must purchase",
                          "url": "https://pokercoaching.com/coupons/StandardF39"
                        });
                      }}
                    >Try standard for free</BrowserLink></td>
                  )}
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>,
    document.getElementById("pc-popup-portal")
  );
};
